module.exports = require("./haw-US.js");